import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * `/admin/users` — now part of `/people`.
 *
 * This screen listed sign-in accounts and their roles over a `profiles` table
 * that shadowed the Cognito user pool, while `/employees` listed the same
 * people as payroll records. Two screens, one human being, and an email-matching
 * sweep to work out which rows on each were the same person.
 *
 * Roles are administered where the person is now, so this redirects rather than
 * 404s: the link is in bookmarks, in notes, and in whatever anybody wrote down.
 */
export const Route = createFileRoute("/_authenticated/admin/users")({
  beforeLoad: () => {
    throw redirect({ to: "/people", replace: true });
  },
});
